import React from 'react';
import { X, Send, Mail } from 'lucide-react';

const ReplyModal = ({
  replyModalOpen,
  closeReplyModal,
  replyData,
  setReplyData,
  sendReply,
  isSendingReply
}) => {
  if (!replyModalOpen) return null;

  return (
    <div className="modal-backdrop" onClick={closeReplyModal}>
      <div className="admin-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title-group">
            <Mail className="modal-icon" />
            <h3>REPLY TO {replyData.name?.toUpperCase() || 'SENDER'}</h3>
          </div>
          <button className="modal-close-btn" onClick={closeReplyModal}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={sendReply} className="modal-body">
          <div className="form-group">
            <label>TO RECIPIENT:</label>
            <input
              type="email"
              value={replyData.to}
              disabled
              className="form-input disabled"
            />
          </div>

          <div className="form-group">
            <label>SUBJECT:</label>
            <input
              type="text"
              value={replyData.subject}
              onChange={(e) => setReplyData((prev) => ({ ...prev, subject: e.target.value }))}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label>REPLY MESSAGE:</label>
            <textarea
              rows="6"
              value={replyData.message}
              onChange={(e) => setReplyData((prev) => ({ ...prev, message: e.target.value }))}
              required
              placeholder="Type your response message here..."
              className="form-textarea"
            ></textarea>
          </div>

          <div className="modal-footer">
            <button type="button" className="admin-action-btn cancel-btn" onClick={closeReplyModal}>
              CANCEL
            </button>

            <button type="submit" className="admin-action-btn primary-btn" disabled={isSendingReply}>
              <Send size={14} />
              <span>{isSendingReply ? 'SENDING EMAIL...' : 'TRANSMIT REPLY'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReplyModal;
